module.exports = __webpack_public_path__ + "static/media/VisionImageLarge.0e310503.jpg";